import React, {FC} from 'react';
import {ItemProps} from '../../types';
import ValidationError from '../ValidationError';

const Range: FC<ItemProps> = (
    {
        formItem,
        validation,
        disabled,
        formData,
        onChange,
        onFocus,
        onBlur,
        onKeyDown,
        autoFocus
    }
) => {


    const inputRef = React.useRef<HTMLInputElement>(null);

    const onFocusHandler = () => {
        inputRef.current?.focus();
    }
    /*const onBlurHandler = (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setActive(false);
        inputRef.current?.focus();
    }*/
    return (
        <>
            <div className={" flex flex-row gap-sm items-center relative group"}>
                <input
                    ref={inputRef}
                    name={formItem.name}
                    type="number"
                    placeholder={formItem.placeholder}
                    disabled={disabled}
                    min={formItem.itemOptions?.min}
                    max={formItem.itemOptions?.max || 50}
                    step={formItem.itemOptions?.step || 1}
                    className={`transition-all outline-none
                        [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
                        ${formItem.disabled ? 'disabled' : ''}
                        w-[90px] text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                        placeholder:text-gray-400 placeholder:text-text-md
                        focus:shadow-focus focus:border-primary-500
                        
                        hover:border-primary-500 shadow-xs
                        h-[44px] px-md
                        
                        ${formItem.classNames?.content || ""}
                        ${validation ? 'border-red-500 border-2 focus:border-red-600 focus:shadow-red hover:border-red-600' : ''}
                    `}
                    autoComplete="off"
                    value={formData[formItem.name] ?? ''}
                    onChange={(e) => {
                        const v = e.target.value;
                        // Allow intermediate states like "-" or "-0" while typing negative numbers
                        if (v === '' || v === '-' || v === '-0' || v === '-0.') {
                            onChange?.(formItem.name, v);
                        } else {
                            onChange?.(formItem.name, v === "0" ? "0" : Number(v));
                        }
                    }}
                    onFocus={onFocus}

                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                />
                <input
                    name={formItem.name}
                    type="range"
                    disabled={disabled}
                    min={formItem.itemOptions?.min}
                    max={formItem.itemOptions?.max || 50}
                    step={formItem.itemOptions?.step || 1}
                    value={formData[formItem.name] ?? formItem.itemOptions?.min ?? 0}
                    onChange={(e) => onChange?.(formItem.name, e.target.value === "0" ? "0" : Number(e.target.value))}
                    onFocus={onFocusHandler}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                    className={`
                        z-[2] relative
                        w-full h-[6px] rounded-md  outline-none transition-all
                        [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-[16px] [&::-webkit-slider-thumb]:w-[16px] [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:hover:bg-primary-500
                        [&::-webkit-slider-thumb]:bg-primary-500 [&::-webkit-slider-thumb]:transition-all [&::-webkit-slider-thumb]:outline [&::-webkit-slider-thumb]:outline-white [&::-webkit-slider-thumb]:shadow-xs
                        
                        
                        
                        bg-gray-200  
                        ${validation ? 'bg-red-500' : ''}
                        ${formItem.classNames?.content || ""}
                    `}
                    style={{
                        WebkitAppearance: 'none',
                    }}
                />
                <span className={"absolute select-none top-0 right-0 text-text-md text-gray-300 z-[1] group-hover:text-gray-900 transition-all"}>
                    {formItem.itemOptions?.max}
                </span>
            </div>
	        <ValidationError error={validation} formItem={formItem} />
        </>
    );
};

export default Range;
